import React from 'react';
import InsightsTableRow from '../_shared/InsightsTableRow';

const LessonActivityRow = ({ number, rowData }) => (
  <InsightsTableRow
    number={number}
    item={rowData.title || 'Untitled Lesson'}
    amount={rowData.activity_count}
    href={rowData.urls.overview}
    icon="preview"
  />
);

export default LessonActivityRow;
